import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BrandButton from "../components/brand-button";
import EmptyCart from "../components/cart/empty-cart";

const CartPage = () => {
    const publicUrl = process.env.PUBLIC_URL;
    const defaultImg = publicUrl + "/img/no-photo.png"
    const { t, i18n } = useTranslation();  
    const continueLbl = i18n.exists("pages.continueLbl") ? t('pages.continueLbl') : "Продължи";
    const storageCart = localStorage.getItem('cartObject');
    const itempLabel = i18n.exists("pages.cartItemLabel") ? t('pages.cartItemLabel') : "Продукт";
    
    const [cartObject, setCartObject] = useState(Object);
    const [stateCart, setStateCart] = useState(Object);

    const getCart = () => {
        if(storageCart) {
            setCartObject(JSON.parse(storageCart));
        }
    }

    const removeItem = (id: any) => {
        console.log(id);
        const storage: any = localStorage.getItem('cartObject');
        if(storage) {
            let storageCart = {...JSON.parse(storage)};
            const updated = storageCart.items.filter((item: any) => {
                return item.id !== id;
            });
            storageCart.items = updated;
            localStorage.setItem('cartObject', JSON.stringify(storageCart));
            setStateCart(storageCart);
        }    


    }

    useEffect(() => {
        getCart();
    }, [stateCart])

    return (
        <div className="cart-page page-spacer">
            <h1 className="page-h1">{i18n.exists("pages.cartPageTitle") ? t('pages.cartPageTitle') : "Кошница"}</h1>
            <div className="content-wrapper">
                {cartObject && cartObject.items && cartObject.items.length > 0 ? (
                    <div className="cart-page-inner">
                        <div style={{'flex' : '1'}}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>{itempLabel}</th>
                                        {/* <th>id</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                {cartObject.items.map((item: any, index: any) => {
                                    return (
                                        <tr key={index}>
                                            <td>
                                                <span onClick={() => removeItem(item.id)} className="remove-item-btn">x</span>
                                                <img src={item.imgSrc ? item.imgSrc : defaultImg} alt="product" className="rounded img-responsive product-thumb" />
                                                {item.title}
                                            </td>
                                            {/* <td>{item.id}</td> */}
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                        <div className="right-bar">
                            {/* <div className="cart-sum">
                                <h3>Суми в количката</h3>
                            </div> */}
                            <div className="align-center">
                                <BrandButton isNavigateBtn={true} text={continueLbl} href='/checkout' title={continueLbl} backgroundColor="#fff" classNameAttr="capitalize"/>
                            </div>
                        </div>
                    </div>
                ) : (
                    <EmptyCart />
                )}
            </div>
        </div>
    )
}

export default CartPage;